// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root___Mxje","clinicsSelect":"TableHeading_clinicsSelect__1lC0J"};